export default function repeat<T>(count: number, value: T): T[] {
  return new Array(count).fill(value);
}
